import React from 'react';
import InfiniteScrollLoadingIndicator from 'app/components/district/InfiniteScrollLoadingIndicator';
import InfiniteScrollErrorMessage from 'app/components/district/InfiniteScrollErrorMessage';
import SeoLinks from 'app/components/seo/SeoLinks';
import CompetitionModule from 'app/components/competitionModule/CompetitionModule';
import AdSlotModel from 'app/components/ads/AdSlotModel';
import { AdSlot } from 'app/components/ads/AdSlot';
import InfiniteScrollTrigger from 'app/components/infiniteScroll/InfiniteScrollTrigger';
import { CompetitionModuleList } from 'app/components/competitionModule/common/CompetitionModuleList';
export default function CompetitionModuleInfiniteList(_ref) {
  let {
    infiniteResponse,
    infiniteCompetitionModules
  } = _ref;
  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    isFetchingNextPage,
    refetch
  } = infiniteResponse;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(InfiniteScrollLoadingIndicator, {
      message: "Wettbewerbe dieser Region werden geladen..."
    });
  }
  if (isError && !infiniteCompetitionModules.hasModules()) {
    return /*#__PURE__*/React.createElement(InfiniteScrollErrorMessage, {
      onRetry: refetch,
      entityName: "Wettbewerbe"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CompetitionModuleList, {
    "data-sentry-element": "CompetitionModuleList",
    "data-sentry-source-file": "CompetitionModuleInfiniteList.tsx"
  }, infiniteCompetitionModules.getInfiniteList().map(moduleData => {
    if (moduleData instanceof AdSlotModel) {
      return /*#__PURE__*/React.createElement(AdSlot, {
        adLayout: moduleData.adLayout,
        key: "ad-".concat(moduleData.adUnit),
        adUnit: moduleData.adUnit,
        limitedDim: false,
        noMargin: true
      });
    } else {
      return /*#__PURE__*/React.createElement(CompetitionModule, {
        key: moduleData.slug,
        data: moduleData
      });
    }
  })), /*#__PURE__*/React.createElement(InfiniteScrollTrigger, {
    onTrigger: fetchNextPage,
    "data-sentry-element": "InfiniteScrollTrigger",
    "data-sentry-source-file": "CompetitionModuleInfiniteList.tsx"
  }), isFetchingNextPage ? /*#__PURE__*/React.createElement(InfiniteScrollLoadingIndicator, {
    message: "Weitere Wettbewerbe dieser Region werden geladen..."
  }) : isError ? /*#__PURE__*/React.createElement(InfiniteScrollErrorMessage, {
    onRetry: refetch,
    entityName: "Wettbewerbe"
  }) : /*#__PURE__*/React.createElement(SeoLinks, {
    data: data.pages
  }));
}